import React, { Component } from 'react'
import {
    Form,
    Row,
    Col,
    Input, InputNumber, Select, Checkbox,
    Button, Table, Popconfirm, Modal, Radio,
    Icon, Card,
    Collapse
} from 'antd';
import { uuid } from '../common/CommonFunc'
import { UserModal } from '../common/UserModal'
import { RoleModal } from '../common/RoleModal'
import {Condition} from './Condition'

const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

class PubInfoFrom extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // parent: props.parent,
            node: props.node,
            show: props.show != null && props.show == true ? props.show : 'none',
            nodedata: props.nodedata,
            percondition:props.percondition == null || props.percondition == true ? true : false,
            aftcondition:props.aftcondition == null || props.aftcondition == true ? true : false,

            loading: false

        }

    }
    setValues(values) {


    }
    // 重新加载页面方法
    reload = () => {
        this.setState({
            loading: false
        });
    }
    // 条件表达式修改事件
    conditionOnChange(attname, e) {
        tool.sgiLogger.log("事件：conditionOnChange")
        let value = e.getValue();
        
        this.refresh(attname, value);
        this.refresh(attname+"Exp", e.getContentStateToRowForJson());
    }
    // 文本修改事件
    textOnChange(attname, e, e2) {
        tool.sgiLogger.log("事件：textOnChange")
        let value = e.target.value;
        this.refresh(attname, value);
    }
    // 下拉窗修改事件
    selectOnChange = (attname, value) => { //change传入对象为value
        tool.sgiLogger.log("事件：selectOnChange")
        this.refresh(attname, value);
    }
    // 复选框组修改事件，checkedValue为数组["01","02"]
    checkboxGroupOnChange = (attname, checkedValue) => {
        tool.sgiLogger.log("事件：checkboxGroupOnChange")
        this.refresh(attname, checkedValue);
    }
    // 单选框组修改事件
    radioGroupOnChange(attname, e) {
        tool.sgiLogger.log("事件：radioGroupOnChange")
        let value = e.target.value;
        this.refresh(attname, value);
    }
    // 数字组件修改事件
    numberOnChange(attname, e) {
        let value = e;
        this.refresh(attname, value);
    }
    // 属性更新
    refresh(attname, value) {
        // || this.state.nodedata.type == "99"
        if (this.state.nodedata.type == "01" ) {

        } else {
            if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id+" "+value);
        }
        this.state.nodedata[attname] = value;
    }
    // 表格添加方法
    // handleAdd = (modalType) => {
    //     tool.sgiLogger.log("handleAdd添加审批人/角色方法");
    //     if (!modalType || modalType == '') {
    //         this.state.modalContent = null;
    //     }
    //     if (modalType == 'user') {
    //         this.state.modalContent = <UserModal key={uuid(8)} modalShow={true}
    //             approvalUserList={this.state.nodedata.users} parent={this} />
    //     } else if (modalType == 'role') {
    //         this.state.modalContent = <RoleModal key={uuid(8)} modalShow={true}
    //             approvalRoleList={this.state.nodedata.roles} parent={this} />
    //     } else if (modalType == 'overTimeout') {
    //         this.state.modalContent = <UserModal key={uuid(8)} modalShow={true}
    //             approvalUserList={this.state.nodedata.overTimeoutUsers} parent={this} />
    //     }
    //     this.setState({
    //         loading: false
    //     });
    // }
    // 表格删除方法
    // handleDelete = (delData, dataSource) => {
    //     if (dataSource && delData) {
    //         for (var i = 0; i < dataSource.length; i++) {
    //             if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
    //                 dataSource.splice(i, 1);
    //             }
    //         }
    //     }
    //     this.setState({ loading: false });
    // }
    // 创建表格绑定store（生成数据key）
    // getTBData = (tData) => {
    //     if (!tData) {
    //         tData = [];
    //         return tData;
    //     }
    //     tData.forEach(element => {
    //         if (!element._key) element._key = uuid(8);
    //     })
    //     return tData;
    // }
    // 刷新form
    componentDidMount() {
        tool.sgiLogger.log('事件：PubInfo加载后')
        this.props.form.setFieldsValue({
            id: this.state.nodedata.id,
            name: this.state.nodedata.name,
            type: this.state.nodedata.type,
            status: this.state.nodedata.status,
            inCondition: this.state.nodedata.inCondition,
            outCondition: this.state.nodedata.outCondition,
            ann: this.state.nodedata.ann,
            isfallback: this.state.nodedata.isfallback,
            fallback: this.state.nodedata.fallback,
            // ishuman: this.state.nodedata.ishuman,
            // interventionUsers: this.state.nodedata.interventionUsers
        });
        if (this.state.percondition) this.refs.inCondition.refreshByContentStateToRowJson(this.state.nodedata.inConditionExp);
        if (this.state.aftcondition) this.refs.outCondition.refreshByContentStateToRowJson(this.state.nodedata.outConditionExp);
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="节点序号">
                            {getFieldDecorator('id', {
                                rules: [{ required: false, message: '' }],
                            })(<Input placeholder="" readOnly
                                onChange={this.textOnChange.bind(this, 'id')}
                            />)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="节点名称">
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: '请输入节点名称' }],
                            })(
                                <Input
                                    style={{ width: '100%' }}
                                    placeholder="请输入节点名称"
                                    onChange={this.textOnChange.bind(this, 'name')}
                                />
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="节点类型">
                            {getFieldDecorator('type', {
                                rules: [{ required: true, message: 'Please select an owner' }],
                            })(
                                <Select placeholder="请选择节点类型" disabled={true}
                                    onChange={this.selectOnChange.bind(this, 'type')}
                                >
                                    <Option value="01">开始节点</Option>
                                    <Option value="02">跳转节点</Option>
                                    <Option value="03">服务节点</Option>
                                    <Option value="04">脚本节点</Option>
                                    <Option value="05">流程节点</Option>
                                    <Option value="06">任务节点</Option>
                                    <Option value="99">结束节点</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="节点状态">
                            {getFieldDecorator('status', {
                                readOnly: true,
                                rules: [{ required: true, message: '请输入节点状态' }],
                            })(
                                <Select placeholder="请选择节点状态" disabled={true}
                                    onChange={this.selectOnChange.bind(this, 'status')}
                                >
                                    <Option value="00">未执行</Option>
                                    <Option value="01">执行中</Option>
                                    <Option value="02">已完成</Option>
                                    <Option value="03">已挂起</Option>
                                    <Option value="04">已驳回</Option>
                                    <Option value="05">已撤销</Option>
                                    <Option value="99">异常</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="允许回退">
                            {getFieldDecorator('isfallback', {
                                rules: [{ required: false, message: '' }],
                            })(
                                <RadioGroup onChange={this.radioGroupOnChange.bind(this, 'isfallback')} >
                                    <Radio value={"0"}>不允许</Radio>
                                    <Radio value={"1"}>允许</Radio>
                                </RadioGroup>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="回退处理">
                            {getFieldDecorator('fallback', {
                                rules: [{ required: false, message: '请输入回退处理' }],
                            })(<Input placeholder="回退处理"
                                onChange={this.textOnChange.bind(this, 'fallback')}
                            />)}
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item label="说明">
                            {getFieldDecorator('ann', {
                                rules: [{ required: false, message: '请输入说明信息' }],
                            })(<Input.TextArea rows={4} placeholder="请输入说明信息"
                                onChange={this.textOnChange.bind(this, 'ann')}
                            />)}
                        </Form.Item>
                    </Col>
                </Row>
                {this.state.percondition?             

                <Row gutter={16}>
                    <Card title="前置处理">
                        <Col span={24}>
                            <Form.Item label="准入条件">
                                {/* {getFieldDecorator('inCondition', {
                                    rules: [{ required: false, message: '请输入准入条件' }],
                                })(
                                    <Condition title="准入条件" onChange={this.conditionOnChange.bind(this, 'inCondition')} contentStateToRowJson={this.state.inCondition}></Condition>
                                    // <Input.TextArea rows={8} placeholder="请输入准入条件"
                                    //     onChange={this.textOnChange.bind(this, 'inCondition')}
                                    ///>
                                    )} */}
                            </Form.Item>
                            <Condition title="准入条件" ref="inCondition" onChange={this.conditionOnChange.bind(this, 'inCondition')} contentStateToRowJson={this.state.inCondition}></Condition>
                                
                        </Col>
                    </Card>
                </Row>
                :null}
                {this.state.aftcondition?    
                <Row gutter={16}>
                    <Card title="后置处理">
                        <Col span={24}>
                            <Form.Item label="准出条件">
                                {/* {getFieldDecorator('outCondition', {
                                    rules: [{ required: false, message: '请输入准出条件' }],
                                })(
                                    <Condition title="准出条件" onChange={this.conditionOnChange.bind(this, 'outCondition')} contentStateToRowJson={this.state.outCondition}></Condition>
                                    // <Input.TextArea rows={8} placeholder="请输入准出条件"
                                    //     onChange={this.textOnChange.bind(this, 'outCondition')}
                                    // />
                                )} */}
                            </Form.Item>
                            <Condition title="准出条件" ref="outCondition" onChange={this.conditionOnChange.bind(this, 'outCondition')} contentStateToRowJson={this.state.outCondition}></Condition>
                        
                        </Col>
                    </Card>
                </Row>
                :null}
            </div>
        )
    }
}

const PubInfo = Form.create()(PubInfoFrom);
export default PubInfo;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Component/PubInfo.js